// extracted by mini-css-extract-plugin
export default {"input":"SegmentedButtonQuestionTile_input__CzRXG"};